import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { productLanes } from '../config/productLanes';

const ProductLanes = () => (
  <section id="lanes" className="py-24 lg:py-32 border-t border-border">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-3xl mb-14">
        <div className="section-label mb-4">Use Cases</div>
        <h2 className="font-display text-4xl lg:text-5xl font-bold leading-[1.1] tracking-tight text-foreground">
          Five certificate use cases for <span className="gradient-text">compliant asset tokenization</span>.
        </h2>
        <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
          Each use case starts with who is responsible, what document is required, and what Tangibl3Net produces before activation.
        </p>
      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
        {productLanes.map((lane) => (
          <article key={lane.id} className="rounded-2xl border border-border bg-card p-6 hover:border-primary/40 hover:shadow-lg hover:shadow-slate-900/5 transition-all">
            <div className="flex items-start justify-between gap-4 mb-4">
              <h3 className="font-display text-xl font-bold text-foreground">{lane.name}</h3>
              <span className="shrink-0 rounded-full border border-border bg-muted/50 px-3 py-1 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
                {lane.riskLevel}
              </span>
            </div>
            <div className="space-y-4 text-[15px] leading-relaxed text-muted-foreground mb-5">
              <p><span className="font-semibold text-foreground">For:</span> {lane.forWhom}</p>
              <p><span className="font-semibold text-foreground">Required document:</span> {lane.requiredDocument}</p>
              <p><span className="font-semibold text-foreground">Tangibl3Net output:</span> {lane.tangibleOutput}</p>
            </div>
            <div className="mb-5">
              <div className="font-mono text-xs uppercase tracking-wider text-foreground mb-3">Core file inputs</div>
              <div className="space-y-2">
                {lane.requiredFiles.slice(0, 4).map((file) => (
                  <div key={file} className="flex items-center gap-2 text-sm text-foreground/80">
                    <CheckCircle2 className="w-4 h-4 text-primary shrink-0" />
                    <span>{file}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex items-center justify-between border-t border-border pt-4">
              <span className="text-xs text-muted-foreground">Human review required</span>
              <a href="#wizard" className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                Check program fit <ArrowRight className="w-3.5 h-3.5" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ProductLanes;
